import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import ProductEditForm from '~/containers/productEdit/productEdit';
import ProductArchive from '~/containers/productArchive/productArchive';

export class ProductEditPage extends Component {
  state = {
    product: null
  };

  onReceiveTransferSchedule = ({ product }) => {
    this.setState({
      product
    });
  };

  render() {
    const productId = this.props.match.params.productId;
    const { product } = this.state;

    const editButton = (
      <div className="flex">
        <ProductArchive className="mr4" product={product} />
        <Link to={`/products`}>
          <Button color="secondary">Cancel</Button>
        </Link>
      </div>
    );

    return (
      <Page>
        <TitleBar back="/products" backText="Products" title={product ? product.name : '...'} button={editButton} />
        <ProductEditForm onCompleted={this.onReceiveTransferSchedule} id={productId} />
      </Page>
    );
  }
}

export default withRouter(ProductEditPage);



// WEBPACK FOOTER //
// ./src/pages/productEdit/productEdit.jsx